module.exports = __webpack_public_path__ + "img/P927.4f8180c6.jpg";